export default "__VITE_ASSET__f8f22623__"